import React, { useEffect, useState } from "react";
import { forgotPassword, validatePassword } from "../../api";
import OtpInputBox from "../OtpInput/otpinput";
import Button from "../../Common/Button/Button";
import PasswordShow from "../../public/images/PasswordShow.svg";
import PasswordHide from "../../public/images/PasswordHide.svg";
import { IoArrowBack as BackIcon } from "react-icons/io5";
import styles from "./forgotPass.module.css";
import { useNavigate } from "react-router";
import { Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { CookieUtils } from "../../axios.config";

const ForgotPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams();
  const initialEmail = searchParams.get("email") || "";
  const [username, setUsername] = useState(initialEmail);
  const [step, setStep] = useState("step1");
  const [hashId, setHashId] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [errorMessage1, setErrorMessage1] = useState("");
  const [errorMessage2, setErrorMessage2] = useState("");
  const [ConfirmErrorMessage, setConfirmErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [token, setToken] = useState("");
  const [passwordReason, setPasswordReason] = useState("forgot_password");

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    const type = passwordType === "password" ? "text" : "password";
    setPasswordType(type);
  };
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordType(
      confirmPasswordType === "password" ? "text" : "password"
    );
  };

  const handleforgotPassword = (userName) => {
    const body = {
      username: userName,
      // reason: "forgot_password",
      reason: passwordReason,
    };
    setLoader(true);
    forgotPassword(body).then((res) => {
      if (res.data) {
        if (res?.data?.code === 200) {
          setLoader(false);
          setStep("step2");
          setHashId(res?.data?.data && res?.data?.data?.hashID);
        } else {
          setLoader(false);
          setErrorMessage1(res?.data?.message);
        }
      } else {
        setErrorMessage1("Something went wrong!");
      }
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleforgotPassword(username);
  };

  const validationForm = () => {
    if (!password) {
      setErrorMessage2("New password is required");
      // return "";
    }
    if (!confirmPassword) {
      setConfirmErrorMessage("Confirm password is required");
      return "";
    }
    if (password.length < 8) {
      setErrorMessage2("Password must be at least 8 characters");
      return "";
    }

    if (confirmPassword !== password) {
      setConfirmErrorMessage("Passwords do not match");
      return "";
    }

    setErrorMessage2("");
    setConfirmErrorMessage("");
    return true;
  };

  const handleconfirmPassword = () => {
    if (!validationForm()) {
      return;
    }
    setLoader(true);
    const body = {
      password: password,
      reason: passwordReason,
    };

    if (!errorMessage2 && !ConfirmErrorMessage) {
      validatePassword(body)
        .then((res) => {
          if (res?.data?.code === 200) {
            setLoader(false);
            navigate("/login");
          } else {
            setLoader(false);
            setErrorMessage2(res?.data?.message || "Something went wrong!");
          }
        })
        .catch((error) => {
          setLoader(false);
          setConfirmErrorMessage(error?.message || "Something went wrong!");
        });
    } else {
      setLoader(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrorMessage2("");
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setConfirmErrorMessage(
      e.target.value !== password ? "Passwords do not match" : ""
    );
  };

  useEffect(() => {
    const tokenValue = CookieUtils.get("token");
    setToken(tokenValue);
    const storedReason = CookieUtils.get("passwordChangeReason");
    if (storedReason) {
      setPasswordReason(storedReason);
      CookieUtils.remove("passwordChangeReason");
    }
    if (tokenValue && tokenValue.access_token) {
      const storedUser = CookieUtils.get("username");
      handleforgotPassword(storedUser);
      setStep("step1");
      setUsername(storedUser);
    } else {
      setStep("step1");
    }
  }, []);

  const onClickBack = () => {
    if (step === "step1") {
      navigate("/login");
    }
    if (step === "step2") {
      setStep("step1");
    }
    if (step === "step3") {
      setStep("step1");
    }
  };
  const handleSuccessfulLogin = () => {};

  return (
    <div className={styles.loginCard}>
      <div className={styles.card}>
        {step !== "step4" && (
          <h3 style={{ position: "relative" }}>
            {(token === null || token === undefined || token === "") && (
              <BackIcon onClick={onClickBack} className={styles.backIcon} />
            )}
            {passwordReason === "change_password"
              ? "Change Password"
              : "Reset Password"}
          </h3>
        )}
        {step === "step1" ? (
          !loader ? (
            <form onSubmit={(e) => handleSubmit(e)}>
              <label>
                Username
                <input
                  type="text"
                  className={styles.username}
                  placeholder="Username"
                  value={username}
                  // onChange={handleChange}
                />
              </label>
              {errorMessage1 !== "" && (
                <div className={styles.errorMessage}>{errorMessage1}</div>
              )}
              <Button
                handleClick={handleSubmit}
                heading={"Send Otp"}
                width="140px"
              />
            </form>
          ) : (
            <div className={styles.spinner}>
              <Spinner animation="border" variant="light" />;
            </div>
          )
        ) : step === "step2" ? (
          <OtpInputBox
            hashId={hashId}
            setHashId={setHashId}
            setStep={setStep}
            handleSuccessfulLogin={handleSuccessfulLogin}
          />
        ) : step === "step3" ? (
          <form>
            <label style={{ position: "relative" }}>
              New Password
              {
                <img
                  style={{ height: "20px", width: "20px" }}
                  alt=""
                  className={styles.toggleIcon}
                  src={
                    passwordType === "password" ? PasswordHide : PasswordShow
                  }
                  onClick={togglePasswordVisibility}
                />
              }
              <input
                type={passwordType}
                className={styles.password}
                placeholder="New Password"
                value={password}
                onChange={handlePasswordChange}
              />
              {errorMessage2 !== "" && (
                <div className={styles.errorMessage}>{errorMessage2}</div>
              )}
            </label>
            <label style={{ position: "relative" }}>
              Confirm Password
              {
                <img
                  style={{ height: "20px", width: "20px" }}
                  alt=""
                  className={styles.toggleIcon}
                  src={
                    confirmPasswordType === "password"
                      ? PasswordHide
                      : PasswordShow
                  }
                  onClick={toggleConfirmPasswordVisibility}
                />
              }
              <input
                type={confirmPasswordType}
                className={styles.password}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
              />
              {ConfirmErrorMessage !== "" && (
                <div className={styles.errorMessage}>{ConfirmErrorMessage}</div>
              )}
            </label>
            <Button
              type="submit"
              handleClick={handleconfirmPassword}
              heading={"Confirm Password"}
            />
          </form>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
